import { INTERFACE_THEME } from '@unifyapps/style/themes/consts';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import type { SnackbarPosition, SnackbarProps } from '@unifyapps/ui/components/Snackbar/types';
import { safeJsonStringify } from '../../../../../utils/json';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useDataColorScheme } from '../../../../hooks/useDataColorScheme';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export type ShowNotificationPayload = {
  title: SnackbarProps['title'];
  description?: SnackbarProps['description'];
  type?: SnackbarProps['color'];
  autoHideDuration?: SnackbarProps['autoHideDuration'];
  position?: SnackbarPosition;
};

function useShowNotification() {
  const { showSnackbar } = useSnackbar();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const colorScheme = useDataColorScheme();

  const onShowNotification: ActionHandlerType = ({ action, actionContext }: OnActionArgs) => {
    const { type, title, autoHideDuration, description, position } =
      action.payload as ShowNotificationPayload;

    const { title: computedTitle, description: computedDescription } = getNoCodeComputedData<{
      title: unknown;
      description: unknown;
    }>({ title, description }, actionContext);

    showSnackbar({
      // @ts-expect-error -- type 'info' exposed here is same as 'default' in ToastColors
      color: type === 'info' ? 'default' : type,
      scheme: colorScheme,
      className: INTERFACE_THEME,
      title:
        typeof computedTitle === 'string'
          ? computedTitle
          : (safeJsonStringify(computedTitle) ?? undefined),
      description:
        typeof computedDescription === 'string'
          ? computedDescription
          : safeJsonStringify(computedDescription),
      autoHideDuration,
      position,
    });

    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  };

  return { onShowNotification };
}

export default useShowNotification;
